<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ tax.id ? "Edit Tax" : "New Tax" }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="taxForm">
    <ion-item lines="none">
      <ion-label position="stacked">Tax Name</ion-label>
      <ion-input
        type="text"
        name=""
        formControlName="name"
        clearInput
      ></ion-input>
    </ion-item>
    <ion-item
      [hidden]="name.valid || (name.pristine && !submitted)"
      lines="none"
    >
      <p *ngIf="name.hasError('required')" class="sm-error">
        Oops, a tax name is required.
      </p>

      <p *ngIf="name.hasError('maxlength')" class="sm-error">
        A tax name can't exceed 50 letters.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Rate</ion-label>
      <ion-input
        [maskito]="percentageMask"
        [maskitoElement]="maskPredicate"
        formControlName="rate"
      >
      </ion-input>
    </ion-item>

    <ion-item [hidden]="rate.valid || (rate.pristine && !submitted)">
      <p *ngIf="rate.hasError('required')" class="sm-error" lines="none">
        Oops, a tax rate is required.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Applies to</ion-label>
      <ion-select
        [(ngModel)]="appliesTo"
        [ngModelOptions]="{ standalone: true }"
      >
        <ion-select-option value="0">Services</ion-select-option>
        <ion-select-option value="1">Products</ion-select-option>
        <ion-select-option value="2">Services & Products</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item [hidden]="appliesTo" lines="none">
      <p *ngIf="!appliesTo" class="sm-error">Oops, appliesTo is required.</p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Biz No</ion-label>
      <ion-input
        type="text"
        name=""
        formControlName="bizNo"
        clearInput
      ></ion-input>
    </ion-item>
    <ion-item
      [hidden]="bizNo.valid || (bizNo.pristine && !submitted)"
      lines="none"
    >
      <p *ngIf="bizNo.hasError('maxlength')" class="sm-error">
        A tax bizNo can't exceed 50 letters.
      </p>
    </ion-item>

    <ion-button
      expand="block"
      fill="clear"
      color="danger"
      class="ion-margin-top"
      (click)="deleteTax()"
      *ngIf="tax.id != undefined"
      >Delete</ion-button
    >
    <br />
  </form>
</ion-content>

<ion-footer class="ion-no-margin">
  <ion-toolbar class="ion-no-margin ion-no-padding">
    <ion-button class="ion-no-margin" expand="block" (click)="save()">
      Save
    </ion-button>
  </ion-toolbar>
</ion-footer>
